<template>
    <div class="body">
        <router-view/>
    </div>
</template>

<script>

export default {
  name: "LeaderBoard",
  data() 
      {
        return {
            isEmbed: this.$store.state.isEmbed || false
        }
      },
    mounted()
    {  
      var th = this
      var lbId = th.$route.params.id

      if( this.isEmbed )
      {
        th.$parent.$parent.$parent.$parent.$parent.resizeWindow(lbId, 'leaderboard_container')
      }

    },
    created()
    {
      this.viewTracker('leaderboard');
    }
  }
</script>